module.exports = __webpack_public_path__ + "static/media/close-side-panel.82137fbe.svg";